import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/node_modules/.pnpm/next@14.2.24_@babel+core@7.26.10_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/image/file.png");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/image/hospital 1.svg");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/assets/logo.png");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/common/aboutdoctor/AboutTurnCom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/aboutdoctor/layout/CarouselAboutDoctors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/aboutdoctor/layout/turn-preview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/admission/Carousel_time_turn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/admission/layout/Content_Roting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/admission/layout/HeaderMission.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/admission/layout/TurnSelection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/auth/FormRegister.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/auth/LoginFunction.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/childid/PaymentCom.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/childid/SectionSendFile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/home/main-search-input.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/LoadingLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/screening/ScreeningComBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/common/sing_label/SetButtonId.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/layout/check-reserve.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/layout/conditional-footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/layout/Navlink.tsx");
;
import(/* webpackMode: "eager" */ "/opt/darmanshirin-front-new/src/components/loader/loader.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/opt/darmanshirin-front-new/src/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetTrigger","SheetContent","SheetDescription","SheetClose"] */ "/opt/darmanshirin-front-new/src/components/ui/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/utils/Accordions_sing_lab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/utils/AccordionSpe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/utils/ComBoxDemo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/utils/CustomfileInput.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/darmanshirin-front-new/src/components/utils/CustomSelectOption.tsx");
